/** Page heading copy and highlighted words from the approved merchant portal HTML. */
const pageHeadings = {
  "/users": {
    prefix: "Your ",
    accent: "team.",
    description: "Manage the people behind your payments.",
  },
  "/transactions": {
    prefix: "Trans",
    accent: "actions.",
    description: "Every payment, all in one place.",
  },
  "/api-key": {
    prefix: "API ",
    accent: "keys.",
    description: "Connect your business to CyberPay.",
  },
  "/payout": {
    prefix: "Payout ",
    accent: "Management.",
    description: "Keep track of outgoing payments.",
  },
  "/settlements": {
    prefix: "All ",
    accent: "settled.",
    description: "Your settlements, reconciled and ready to review.",
  },
  "/pay-by-link": {
    prefix: "Send a link. ",
    accent: "Get paid.",
    description: "A simple way to collect a payment, wherever your customers are.",
  },
  "/reports": {
    prefix: "The full ",
    accent: "picture.",
    description: "Your payment reporting, on your schedule.",
  },
  "/webhooks": {
    prefix: "Web",
    accent: "hooks.",
    description: "Keep your systems in sync with every payment.",
  },
  "/settings": {
    prefix: "Make it ",
    accent: "yours.",
    description: "Your brand. Your customer experience.",
  },
};

export default pageHeadings;
